import React from 'react'
import NavbarComponent from './navbar'
import TabsComponent from './tap'
import Dashboard from './interfaceDashbrd'
import Footer from './footer'

export default function Synergyscreens() {
  return (
    <div className='synergyscreen'>
      <div className='synergyscreenfirstsec' >
       <div>
        <NavbarComponent/>
       </div>

       <div style={{ position: "absolute", top: "146px", right: "107px" }}>
            <TabsComponent/>
          </div>

          <div className='interfacesectionsynergyscren'>
<div className='intermadetxt' id='intermade'>Interfaces <br />
made for <span className='intermadetspanxt'>Collaboration.</span></div>
<div className='universetxt'>Built screens for Universal needs.</div>
</div>
      </div>

<div className='interfacetab'>
    <div className=''>
    <Dashboard/>
    </div>

    <div className='collabrateinteface'>
       <div className='cllaparatetools'>Collaborate across <span className='teamstxt'>tools and teams</span></div>
       <div className='cllaparatepara'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore </div>
      </div>


<br></br>
</div>



<div>
<Footer/>  
</div>


    </div>
  )
}
